import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { ButtonGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Button } from 'reactstrap'
import { isSocialEnabledForStoreView } from '../CustomerAccount/Dashboard/social/isSocialEnabled'
import SelectPaginate from '../general/SelectPaginate'

const MyAccountDropdown = ({
  dropdownOpen,
  toggleDropdown,
  currentUser,
  props: { downloadableItems, currentLocation, socialPosts = [] },
  handleClickLogOut,
  changeLocation,
  fetchAsyncLocations,
  isMobile,
  portal,
  isAdminUserPath,
  selectableLocations = [],
  canSwitchLocations,
  isPunchoutMode
}) => {
  const showAdminNavButton = currentUser?.is_admin_user
  const socialEnabled = isSocialEnabledForStoreView(portal, currentLocation)
  const userHasSocialPosts = socialEnabled && socialPosts.length > 0

  return (
    <ButtonGroup>
      <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} group>
        <DropdownToggle
          href="/"
          tag="a"
          className="nav-link dropdown-user-link mf-primary-nav-btn"
          onClick={e => e.preventDefault()}
        >
          <div className="mf-text-center">
            <div className="d-flex align-items-center justify-content-center">
              <span>
                <span className="my-account">My Account</span>
                <span>
                  <i className="fa-duotone fa-user icon-right-margin"></i>
                </span>
              </span>
            </div>
          </div>
        </DropdownToggle>
        <DropdownMenu right className="account-drop-down-mobile">
          {showAdminNavButton && (
            <>
              <DropdownItem className="dropdown-item-full-width">
                {isAdminUserPath ? (
                  <Button
                    tag={Link}
                    to="/"
                    className="mf-outline-btn dropdown-button-full-width d-flex align-items-center justify-content-center btn-smaller-height"
                  >
                    <div className="d-flex align-items-center">
                      <i className="fa-solid fa-chevron-left icon-right-margin icon-size-20 mf-me-2"></i>
                      <span>Return to Store</span>
                    </div>
                  </Button>
                ) : (
                  <Button
                    tag={Link}
                    to="/admin"
                    className="mf-outline-btn dropdown-button-full-width d-flex align-items-center justify-content-center btn-smaller-height"
                  >
                    <div className="d-flex align-items-center">
                      <i className="fa-duotone fa-shield-keyhole icon-right-margin icon-size-20 mf-me-2"></i>
                      <span>Access Admin</span>
                    </div>
                  </Button>
                )}
              </DropdownItem>
              <DropdownItem divider />
            </>
          )}
          <DropdownItem header>Hi, {currentUser?.first_name}!</DropdownItem>

          {currentUser?.id && (
            <>
              <DropdownItem tag={Link} to="/customer/account/dashboard" className="dropdown-item-custom">
                <i className="fa-duotone fa-gauge icon-right-margin icon-size-20"></i>
                Dashboard
              </DropdownItem>
              <DropdownItem tag={Link} to="/customer/account/profile" className="dropdown-item-custom">
                <i className="fa-duotone fa-user icon-right-margin icon-size-20"></i>
                Profile
              </DropdownItem>
              <DropdownItem tag={Link} to="/customer/account/orders" className="dropdown-item-custom">
                <i className="fa-duotone fa-box-taped icon-right-margin icon-size-20"></i>
                Orders
              </DropdownItem>
              {downloadableItems.length > 0 && (
                <DropdownItem tag={Link} to="/customer/account/downloads" className="dropdown-item-custom">
                  <i className="fa-duotone fa-download icon-right-margin icon-size-20"></i>
                  Downloads
                </DropdownItem>
              )}
              {socialEnabled && (
                <DropdownItem tag={Link} to="/customer/account/social" className="dropdown-item-custom">
                  <i className="fa-duotone fa-bullhorn icon-right-margin icon-size-20"></i>
                  Social Accounts
                </DropdownItem>
              )}
              {userHasSocialPosts && (
                <DropdownItem tag={Link} to="/customer/account/social-posts" className="dropdown-item-custom">
                  <i className="fa-duotone fa-share-nodes icon-right-margin icon-size-20"></i>
                  Social Posts
                </DropdownItem>
              )}
              {!isPunchoutMode && (
                <DropdownItem tag={Link} to="/customer/account/credit-balance" className="dropdown-item-custom">
                  <i className="fa-duotone fa-credit-card-blank icon-right-margin icon-size-20"></i>
                  Credit Balance
                </DropdownItem>
              )}
              <DropdownItem
                tag={Link}
                to="/customer/account/addresses"
                className="dropdown-item-custom"
                style={{ marginBottom: '10px' }}
              >
                <i className="fa-duotone fa-address-book icon-right-margin icon-size-20"></i>
                Addresses
              </DropdownItem>
              <div style={{ width: '250px', marginLeft: '25px' }}>
                {isMobile &&
                  currentUser &&
                  selectableLocations.length > 1 &&
                  !isAdminUserPath &&
                  canSwitchLocations && (
                    <Dropdown className="first navbar-location">
                      <SelectPaginate
                        id="location"
                        onChange={changeLocation}
                        defaultValue={localStorage.getItem('currentlocationId') || currentLocation}
                        value={currentLocation}
                        fetchData={fetchAsyncLocations}
                        data="locations"
                      />
                    </Dropdown>
                  )}
              </div>
            </>
          )}
          <DropdownItem divider />
          {currentUser?.id && (
            <DropdownItem className="dropdown-item-full-width">
              <Button
                onClick={handleClickLogOut}
                className="mf-outline-btn dropdown-button-full-width d-flex align-items-center justify-content-center btn-smaller-height"
              >
                <div className="d-flex align-items-center">
                  <i className="fa-duotone fa-right-from-bracket icon-right-margin icon-size-20 me-2"></i>
                  <span>Sign Out</span>
                </div>
              </Button>
            </DropdownItem>
          )}
          <div
            className={`d-flex ${portal.portal_has_terms_and_conditions_link ? '' : 'justify-content-center'}`}
            style={{ width: '100%' }}
          >
            {portal.portal_has_terms_and_conditions_link && (
              <>
                <DropdownItem className="terms-and-conditions-dropdown">
                  <div className="terms-and-conditions-link-container">
                    <Link to={portal.terms_and_conditions_link} className="terms-and-conditions-link">
                      Terms and Conditions
                    </Link>
                  </div>
                </DropdownItem>
                <div className="divider">|</div>
              </>
            )}
            <DropdownItem
              className={`${
                portal.portal_has_terms_and_conditions_link ? 'contact-us-dropdown' : 'dropdown-item-center'
              }`}
            >
              <div
                className={`${
                  portal.portal_has_terms_and_conditions_link
                    ? 'contact-us-link-container'
                    : 'contact-us-center-container'
                }`}
              >
                <a href={`tel:${portal.portal_header_phone_number}`} className="contact-us-link">
                  Contact Us
                </a>
              </div>
            </DropdownItem>
          </div>
        </DropdownMenu>
      </Dropdown>
    </ButtonGroup>
  )
}

MyAccountDropdown.propTypes = {
  dropdownOpen: PropTypes.bool,
  toggleDropdown: PropTypes.func,
  currentUser: PropTypes.shape({
    id: PropTypes.string,
    first_name: PropTypes.string,
    is_admin_user: PropTypes.bool
  }),
  props: PropTypes.shape({
    downloadableItems: PropTypes.arrayOf(PropTypes.any),
    socialPosts: PropTypes.arrayOf(PropTypes.any),
    currentLocation: PropTypes.string
  }),
  handleClickLogOut: PropTypes.func,
  changeLocation: PropTypes.func,
  fetchAsyncLocations: PropTypes.func,
  isMobile: PropTypes.bool,
  portal: PropTypes.shape({
    portal_has_terms_and_conditions_link: PropTypes.bool,
    terms_and_conditions_link: PropTypes.string,
    portal_header_phone_number: PropTypes.string
  }),
  isAdminUserPath: PropTypes.bool,
  selectableLocations: PropTypes.arrayOf(PropTypes.any),
  canSwitchLocations: PropTypes.bool,
  isPunchoutMode: PropTypes.bool
}

export default MyAccountDropdown
